import PropTypes from 'prop-types';
import { getPrice } from '../../common/routines/utils';
import { formatDate } from '../../utils/formatters';

const IndividualStatementRow = ({ rowData, id }) => {
  const {
    date,
    contractNumber,
    onePortalId,
    name,
    totalAmount,
    balanceDue,
    addendumNumber,
    toComment,
    fromComment,
  } = rowData;

  const getAmount = () => {
    if (!(name.includes('Payment') || name.includes('Discount'))) {
      return getPrice(totalAmount);
    }
    return '';
  };
  const getPayment = () => {
    if (name.includes('Payment')) {
      return `(${getPrice(totalAmount)})`;
    }
    return '';
  };
  const getDiscount = () => {
    if (name.includes('Discount')) {
      return `(${getPrice(totalAmount)})`;
    }
    return '';
  };
  const getContractNumber = () => {
    if (addendumNumber) {
      return addendumNumber;
    }
    return contractNumber;
  };
  return (
    <tr key={id} className="table-body-tr">
      <td>{id}</td>
      <td>{formatDate(date)}</td>
      <td>{getContractNumber()}</td>
      <td>{onePortalId || '-'}</td>
      <td>
        {name}
        {toComment && (
          <>
            <br />
            <span className="comment">{toComment}</span>
          </>
        )}
        {fromComment && (
          <>
            <br />
            <span className="comment">{fromComment}</span>
          </>
        )}
      </td>
      <td>{getAmount()} </td>
      <td>{getPayment()}</td>
      <td>{getDiscount()}</td>
      <td>{getPrice(balanceDue)}</td>
    </tr>
  );
};

IndividualStatementRow.propTypes = {
  rowData: PropTypes.shape({
    date: PropTypes.string,
    balanceDue: PropTypes.number,
    contractNumber: PropTypes.string,
    onePortalId: PropTypes.string,
    name: PropTypes.string,
    totalAmount: PropTypes.number,
    addendumNumber: PropTypes.string,
    toComment: PropTypes.string,
    fromComment: PropTypes.string,
  }).isRequired,
  id: PropTypes.number.isRequired,
};

export default IndividualStatementRow;
